import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { cnBem } from '@carnica/utils';
// TODO временно меняем на @beef/ui-kit, т.к. из карники ломает серверный рендеринг
import { useIsMobileDimension } from '@beef/ui-kit';
import { Text } from '@carnica/ui-kit';
import { cnTheme } from '@carnica/themes';
import { IconCloseRoundStroked, IconLogoutOutline } from '@carnica/graphics';
import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withMountListener } from '@beef/react';
import { pushPersonalAccountAnalytics } from "../../../utils";
import { ActionCreator } from "../../store/actions";
import styles from "./styles.pcss";
import { Accounts } from "./Accounts";
import { CardList } from "./CardList";
import { NonAuth } from "./NonAuth";
import { TITLES } from "./constants";
import { handleLogOut } from "./utils";
import { ConnectionBlock } from "./ConnectionBlock";
import { Notifications } from "./Notifications";
import { selectUserType } from "../../store/selectors";
var cnContainer = cnBem('container', styles);
export var _Container = function _Container(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
    onClose = _ref.onClose,
    isAuth = _ref.isAuth,
    userType = _ref.userType;
  useEffect(function () {
    document.body.style.overflowY = isOpen ? 'hidden' : 'scroll';
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    accountsIsOpen = _useState2[0],
    setAccountsIsOpen = _useState2[1];
  var isMobile = useIsMobileDimension();
  var handleClose = function handleClose() {
    if (window) {
      pushPersonalAccountAnalytics({
        icon_type: 'close',
        account_type: userType
      });
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cnContainer(null, cnTheme('dark')),
    "data-t-id": "components-Container"
  }, /*#__PURE__*/React.createElement("div", {
    className: cnContainer({
      wrapper_hidden: !isOpen
    }, ['wrapper']),
    onClick: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: cnContainer({
      main_hidden: !isOpen
    }, ['main'])
  }, /*#__PURE__*/React.createElement("div", {
    className: cnContainer(null, ['side-menu-container'])
  }, /*#__PURE__*/React.createElement("div", {
    className: cnContainer(null, ['profile-title'])
  }, /*#__PURE__*/React.createElement(Text, {
    className: cnContainer(null, ['title-text']),
    size: isMobile ? 'm' : 'l'
  }, isAuth ? TITLES.IS_AUTHORISED : TITLES.NOT_IS_AUTHORISED), /*#__PURE__*/React.createElement(IconCloseRoundStroked, {
    className: cnContainer(null, ['close-button']),
    color: "primary",
    onClick: handleClose,
    size: 28,
    tagName: "button"
  })), /*#__PURE__*/React.createElement("div", {
    className: cnContainer(null, ['content'])
  }, isAuth ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cnContainer({
      accounts_expanded: accountsIsOpen
    }, ['accounts'])
  }, /*#__PURE__*/React.createElement(Accounts, {
    isOpen: accountsIsOpen,
    setIsOpen: setAccountsIsOpen
  })), /*#__PURE__*/React.createElement(Notifications, {
    isSideMenuOpen: isOpen,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(ConnectionBlock, null), /*#__PURE__*/React.createElement(CardList, null), /*#__PURE__*/React.createElement("button", {
    className: cnContainer(null, ['logout-button']),
    onClick: function onClick() {
      return handleLogOut(userType);
    },
    type: "submit"
  }, /*#__PURE__*/React.createElement(IconLogoutOutline, {
    color: "error"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "error",
    size: "s"
  }, "\u0432\u044B\u0439\u0442\u0438"))) : /*#__PURE__*/React.createElement(NonAuth, {
    isOpen: isOpen
  })))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    userType: selectUserType(state)
  };
};
var mapDispatchToProps = {
  onMount: ActionCreator.fetchCommonData
};
export var Container = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(_Container);